"use client"

import ContactForm from "components/Contact/ContactForm";
import React from "react";

export default function PartnerContact(props) {
    const {
        reverse = false,
        className = "red-color",
        text = "Partner with Us",
        id = "publisher-contact",
        persona = "Publisher",
        message = "Get in Touch",
        title = "Get In Touch",
        actionText = "Get In Touch",
        successTitle = "Thank you for joining the waitlist!",
        successMessage = "Our team will contact you to schedule a call about using purchase intelligence to turbo charge your marketing.",
        subMessage = "",
        ...other
    } = props


    const [partnerForm, setPartnerForm] = React.useState(false)

    return (<>
            <div className={`d-flex ${reverse ? "justify-content-start" : "justify-content-end"} mt-4 mb-4 mr-10`}>
                <div onClick={() => setPartnerForm(true)}
                     className={`theme-btn wow fadeInUp rounded-pill cursor-pointer ${className}`}
                     data-wow-duration="1s" id={id}>
                    {text}
                </div>
            </div>
            <ContactForm id="publisher-contact"
                         open={partnerForm}
                         onClose={() => setPartnerForm(false)}
                         message={message}
                         title={title}
                         persona={persona}
                         subMessage={subMessage}
                         actionText={actionText}
                         successTitle={successTitle}
                         successMessage={successMessage}
                         {...other}
            />
        </>
    );

}
